// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobileProductData {
  height: 100%;
  overflow-y: auto;
}

.mobileProductLoader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.mobProuductsCard {
  border: 1px solid var(--surface-g1);
  background-color: var(--surface-white);
  border-radius: 8px;
  margin-bottom: 8px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mobProductImg {
  height: 44px;
  width: 44px;
}

.mobProductsLeftContainer {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mobPriceContainer {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mobProductName {
  font-weight: 700;
}

.mobProductPrice {
  font-weight: 700;
}

.mobShortCode {
  font-weight: 700;
  color: var(--surface-g4);
}

.mobileOptionsInputWrapper {
  position: relative;
  width: 100%;
}

.mobileOptionsInputWrapper > *:first-child {
  position: absolute;
  top: 50%;
  left: 0.5rem;
  transform: translateY(-50%);
  pointer-events: none;
}

.mobileOptionsSearch {
  font-size: 0.813rem;
  padding-left: 40px;
  padding-top: 8px;
  padding-bottom: 8px;
  width: 100%;
  background-color: var(--surface-g1);
  border: none;
  border-radius: 6px;
}

.mobileCategoryHeaderContainer {
  margin-bottom: 12px;
}

.mobileSearchClearIcon {
  position: absolute;
  top: 50%;
  right: 0.5rem;
  transform: translateY(-50%);
  background-color: var(--surface-white);
  padding: 2px 6px;
  border-radius: 16px;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/MobileProductList.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,2BAA2B;EAC3B,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".mobileProductData {\n  height: 100%;\n  overflow-y: auto;\n}\n\n.mobileProductLoader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.mobProuductsCard {\n  border: 1px solid var(--surface-g1);\n  background-color: var(--surface-white);\n  border-radius: 8px;\n  margin-bottom: 8px;\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.mobProductImg {\n  height: 44px;\n  width: 44px;\n}\n\n.mobProductsLeftContainer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.mobPriceContainer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.mobProductName {\n  font-weight: 700;\n}\n\n.mobProductPrice {\n  font-weight: 700;\n}\n\n.mobShortCode {\n  font-weight: 700;\n  color: var(--surface-g4);\n}\n\n.mobileOptionsInputWrapper {\n  position: relative;\n  width: 100%;\n}\n\n.mobileOptionsInputWrapper > *:first-child {\n  position: absolute;\n  top: 50%;\n  left: 0.5rem;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n.mobileOptionsSearch {\n  font-size: 0.813rem;\n  padding-left: 40px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  width: 100%;\n  background-color: var(--surface-g1);\n  border: none;\n  border-radius: 6px;\n}\n\n.mobileCategoryHeaderContainer {\n  margin-bottom: 12px;\n}\n\n.mobileSearchClearIcon {\n  position: absolute;\n  top: 50%;\n  right: 0.5rem;\n  transform: translateY(-50%);\n  background-color: var(--surface-white);\n  padding: 2px 6px;\n  border-radius: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
